export enum ELoginScreenState {
  LOADING = 1,
  LOGIN_ID,
  PASSWORD,
  YOB,
  ETOTP,
  OTP,
  ACC_OPENING,
  LEAD_FORM,
  LOGIN_WITH_API_KEY,
  PASSWORD_WITH_API_KEY,
  ETOTP_WITH_API_KEY,
  YOB_WITH_API_KEY,
  OTP_WITH_API_KEY,
}

export enum ELoginPopupState {
  LOGINID_SENT = 1,
  EMAIL_SENT,
  PASSWORD_UPDATE,
  OPEN_ACC_SUCC,
}

export const urls = {
  login: "/login",
};
